module.exports = __webpack_public_path__ + "img/Global.a040f431.svg";